import React, { Component } from 'react';
import styles from "../../../styles/components/failure.module.scss"

export default class Failure extends Component {
    render() {
        return (
            <>
                <div className={styles.outer}>
                    <div className={styles.inner}>!</div>
                </div>
            </>
        )
    }
}
